var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("span", {
        staticClass: "png-icon cursor-pointer float-right",
        class: _vm.isMobile
          ? "png-icon-icons-glyph--ko-heart"
          : "png-icon-icons-glyph--k-heart",
        on: {
          click: function($event) {
            return _vm.addToProject()
          }
        }
      }),
      _vm._v(" "),
      _c(
        "modal",
        {
          staticClass: "my-project-modal",
          attrs: {
            height: "650",
            name: "project-wizard-webPage-content-modal-" + _vm.dynamicId,
            "data-html2canvas-ignore": "true",
            adaptive: true,
            scrollable: true
          }
        },
        [
          _c("pc-project-wizard-content-modal", {
            attrs: { isMobile: _vm.isMobile },
            on: {
              closeModal: function($event) {
                return _vm.closeModal($event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }